import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadingNextIssuePageFailedFlagTitle: {
		id: 'software-deployments.timeline.loading-next-issue-page-failed-flag-title',
		defaultMessage: 'Unable to load more issues.',
		description:
			'When loading the next page fails, we show this error title in the bottom-left corner together with description',
	},
	loadingNextIssuePageFailedFlagDescription: {
		id: 'software-deployments.timeline.loading-next-issue-page-failed-flag-description',
		defaultMessage: 'Please try to load the next page again.',
		description:
			'When loading the next page fails, we show this error message in the bottom-left corner',
	},
});
